module.exports = __webpack_public_path__ + "img/Alloxentric-logomark.a228dd7c.png";